import StorageHelper from 'Stores/helper';

const scope = 'CAMPAIGNS/cancelTokens';

const mod = {
    namespaced: true,
    state: {
      cancelSources: {
        legislatorResults: "",
       },
    },
    mutations: {
      cancelSources(state, cancelSourceObject) {
        state.cancelSources = {
          ...state.cancelSources,
          [cancelSourceObject.apiName]: cancelSourceObject.value
        };
       },
    },
    actions: {
      cancelSources({commit}, cancelSourceObject) {
        commit("cancelSources", cancelSourceObject);
      },
    },
    getters: {
      cancelSources(state) {
        return state.cancelSources;
      },
    },
};

export default mod;
